import { t } from "i18next"
import TitleModal from "../common/titleModal"
import BoxPrenotationLink from "./boxPrenotationLink"

const BoxPrenotationLinks = (props: any) => {

  let prenotations = props.prenotations || []

  return (
    <>
      {((prenotations.length) ?
        <div className="footer">

          <div className="col-12 mt-4 ">
            <TitleModal title={t('reservations')} />

            <div className="boxPrenotationLinks">
              {prenotations.map((prenotation: any, index: any) =>
                <BoxPrenotationLink handleClick={() => { props.clickPrenotationLink(prenotation?._id) }} key={index} prenotation={prenotation} />
              )
              }

            </div>
          </div>
        </div>
        :
        <></>
      )}
    </>


  )
}

export default BoxPrenotationLinks;
